import { render, staticRenderFns } from "./MessageContainer.vue?vue&type=template&id=a67c652e&scoped=true"
import script from "./MessageContainer.vue?vue&type=script&lang=js"
export * from "./MessageContainer.vue?vue&type=script&lang=js"
import style0 from "./MessageContainer.vue?vue&type=style&index=0&id=a67c652e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67c652e",
  null
  
)

export default component.exports